import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
// Back-office utilities live in their own stylesheet so they stay out of the
// public site's render-blocking CSS.
import adminCss from "../styles.admin.css?url";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  head: () => ({ links: [{ rel: "stylesheet", href: adminCss }] }),
  beforeLoad: async ({ location }) => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      if (location.pathname.startsWith("/partner")) {
        const searchParams = new URLSearchParams(location.searchStr || "");
        const code = searchParams.get("code");
        const target = {
          to: "/partner/login",
          search: {
            next: "/partner/onboarding",
            ...(code ? { code } : {}),
          } as never,
          ...(location.hash ? { hash: location.hash } : {}),
        } as const;
        throw redirect(target);
      }
      throw redirect({ to: "/login", search: { redirect: location.href } as never });
    }
    return { user: data.user };
  },
  component: () => <Outlet />,
});
